import { StyleSheet, Text, View } from "react-native";

import {
  spacing,
  type,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

export function PageTitle({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <View>
      <Text style={stylesheet.title}>{title}</Text>
      {subtitle ? <Text style={stylesheet.subtitle}>{subtitle}</Text> : null}
    </View>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    title: {
      ...type.h1,
      color: colors.heading,
    },
    subtitle: {
      ...type.sm,
      marginTop: spacing.s,
      maxWidth: 640,
      color: colors.mutedForeground,
    },
  });
